import React from "react";
import { Alert, Button } from "react-bootstrap";
import { faPowerOff } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface ErrorDisplayProps {
    errorMessage: string;
    onLogout: () => void;
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
    errorMessage,
    onLogout
}) => {
    return (
        <Alert variant="danger">
            {errorMessage}
            <div className="form-group d-grid">
                <Button 
                    className="mt-2 text-start" 
                    variant="outline-primary" 
                    onClick={onLogout}
                >
                    <FontAwesomeIcon icon={faPowerOff} fixedWidth /> Sign Out
                </Button>
            </div>
        </Alert>
    );
};
